import React from 'react';
import PropTypes from 'prop-types';

import PartnerRows from './PartnerRows';
import flagEU  from './../../../assets/images/icons/eu.svg';
import { findFlagUrlByIso3Code } from "country-flags-svg";
import { translateStaticContent } from '../../../helpers/translateStaticContent';

const Bound = (props) => {
    let flagUrl = '';
    if (props.countryIso3 !== 'Європейський Союз') {
        flagUrl = findFlagUrlByIso3Code(props.countryIso3)
    } else {
        flagUrl = flagEU;
    }
    
     return(
        <div className="bound-table">
            <div className="table-column country">
                 <div className="table-header">
                    {translateStaticContent('tableDataState', 
                        props.defaultStaticContentTariffs, props.activeLangStaticContentTariffs)}
                </div>
                <div className="table-data" id={`${props.direction}${props.countryName}`}>
                    <span className="state-logo">
                         <img src={flagUrl} alt={props.countryName} referrerPolicy="no-referrer"/>
                         <span>{props.countryName}</span>
                     </span>
                </div>
            </div>
            <div className="table-column">
                 <PartnerRows rows={props.list}
                              direction={props.direction}
                              defaultStaticContentTariffs={props.defaultStaticContentTariffs}
                              activeLangStaticContentTariffs={props.activeLangStaticContentTariffs}/>
            </div>
        </div>
    )   
}

export default Bound;

Bound.propTypes = {
    countryName: PropTypes.string.isRequired,
    list:  PropTypes.array.isRequired,
    countryIso3: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    defaultStaticContentTariffs: PropTypes.object,
    activeLangStaticContentTariffs: PropTypes.object,
}